module.exports = __webpack_public_path__ + "img/image5.d13c0554.jpeg";